export default __webpack_public_path__ + "static/media/Ун_20л.eb396a58.jpg";